import React, { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export interface Props extends ReactDatePickerProps {
  classNames?: string;
}

const DatePicker = (ReactDatePicker as unknown as { default: typeof ReactDatePicker }).default ?? ReactDatePicker;

const DayPickerInput = forwardRef<
  HTMLButtonElement,
  DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement> & { placeholder?: string },
    HTMLButtonElement
  >
>(({ placeholder, value, ...rest }, ref) => <button ref={ref} type='button' {...rest}>{value || placeholder}</button>);

DayPickerInput.displayName = 'DayPickerInput';

const dayPickerClasses = 'flex p-2 mx-auto h-10 w-40 border-[1px] border-gray-400 outline-none rounded-md focus:border-sapphire focus:ring-0 focus:ring-offset-0 focus:outline-none';

export const DayPicker = (props: Props): JSX.Element => {
  const { classNames, ...rest } = props;

  return (
    <DatePicker
      {...rest}
      className={`${dayPickerClasses}${classNames ? ` ${classNames}` : ''}`}
      customInput={<DayPickerInput />}
      enableTabLoop={false}
      popperClassName='z-50'
    />
  );
};
